import { FieldRenderProps } from "react-final-form";
import { Autocomplete, TextField } from "@mui/material";
import { GenericInputProps } from "../types";

export type AutoCompleteFieldProps = FieldRenderProps<GenericInputProps, any>;

const AutoCompleteField: React.FC<AutoCompleteFieldProps> = ({
    input,
    meta,
    options = [],
    helperText,
    label,
    ...props
}) => {
    const { invalid, touched, error, submitError } = meta;
    const hasError = invalid && touched;
    return (
        <Autocomplete
            {...props}
            multiple
            options={options}
            value={options.filter((option: any) =>
                ((input.value ?? []) as string[]).includes(option.id)
            )}
            getOptionLabel={(option) =>
                `${option.label}`
            }
            isOptionEqualToValue={(option, value) =>
                option.id === value.id
            }
            onChange={(_, selectedPeople) =>
                input.onChange(selectedPeople.map((person) => person.id))
            }
            renderInput={(params) => (
                <TextField
                    {...params}
                    label={`${label} ${props.required && " *"}`}
                    placeholder="Search "
                    error={hasError}
                    helperText={hasError ? error || submitError : helperText}

                />
            )}
        />
    );
};

export default AutoCompleteField;